import { CSSProperties } from 'react';

const CHIP_HEIGHT_RATIO = 1.8;
const CHIP_PADDING_X_TRIM = 3;

// Pill sizes scale with the MAC font size, exactly like the admin editor's getChipMetrics.
export function getChipStyleVars(fontSize: number): CSSProperties {
    return {
        '--mac-chip-font-size': `${fontSize}px`,
        '--mac-chip-height': `${Math.round(fontSize * CHIP_HEIGHT_RATIO)}px`,
        '--mac-chip-padding-x': `${fontSize - CHIP_PADDING_X_TRIM}px`,
    } as CSSProperties;
}

export function getScaleStyleVars(scale: number): CSSProperties {
    return { '--mac-scale': scale } as CSSProperties;
}
